export default [
  {
    header: 'Biglietteria',
    resource: 'biglietteria',
    action: 'read',
  },
  {
    title: 'Import Tracciati',
    route: 'importa-tracciati-biglietteria',
    resource: 'biglietteria-full',
    action: 'read',
    icon: 'TrelloIcon',
  },
  {
    title: 'Import Utenti',
    route: 'importa-utenti-biglietteria',
    resource: 'biglietteria-full',
    action: 'read',
    icon: 'TrelloIcon',
  },
  {
    title: 'Visualizza Tracciati',
    route: 'tracciati-biglietteria',
    resource: 'biglietteria-full',
    action: 'read',
    icon: 'TrelloIcon',
  },
  {
    title: 'Chart Biglietteria',
    route: 'chart-biglietteria',
    resource: 'chart-biglietteria',
    action: 'read',
    icon: 'TrelloIcon',
  },
  {
    title: 'Statistiche Scritture',
    route: 'statistiche-scritture',
    resource: 'biglietteria-full',
    action: 'read',
    icon: 'TrelloIcon',
  },
  {
    title: 'Riepilogo Incassi',
    route: 'riepilogo-incassi-biglietteria',
    resource: 'incassi-biglietteria',
    action: 'read',
    icon: 'TrelloIcon',
  },
]
